import { ParticipantType } from 'features/getParticipants/types';
import { AddParticipantDataReqType } from 'features/addParticipant/types';
import { toast } from 'react-toastify';
import { partApi } from './model/usersApi';

type PhoneListType = {
  id: number;
  phone: string;
  user_id: number;
  user: {
    avatar_guid: string;
    avatar_url: string;
    channel: string;
    first_name: string;
    id: number;
    iin: number;
    last_name: string;
    middle_name: string;
    status: number;
  };
};

type ParticipantsListType = {
  items: ParticipantType[];
  total: number;
  page: number;
  size: number;
};

const getParticipantsApi = partApi.injectEndpoints({
  endpoints: (builder) => ({
    getParticipants: builder.query<ParticipantsListType, { page: number; size: number; search: string }>({
      query: ({ page, size, search }) =>
        `/sales-point/admin/sales-point/admin/sales-points/?page=${page}&size=${size}&search=${search}`,
    }),
    getParticipantsPromoId: builder.query<any, { id: string | undefined; search?: string }>({
      query: ({ id, search = '' }) =>
        `/promo-b2b/admin/promo-b2b/admin/activities/${id}/participants/${search && `?search=${search}`}`,
      providesTags: ['PartPromo'],
    }),

    getTest: builder.query<ParticipantType, number>({
      query: (id) => ({
        url: `/sales-point/admin/sales-point/admin/sales-points/${id}/`,
      }),
      providesTags: ['Part'],
    }),
    getPhones: builder.query<PhoneListType[], string>({
      query: (id) => ({
        url: `sales-point/admin/sales-point/admin/sales-points/${id}/phones/?page=1&size=50`,
      }),
      providesTags: ['Part'],
    }),
    addParticipant: builder.mutation<any, AddParticipantDataReqType>({
      query: ({ id, body }) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/activities/${id}/add_participant/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили новую торговую точку', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['PartPromo'];
      },
    }),
  }),
});

export const {
  useGetParticipantsQuery,
  useGetParticipantsPromoIdQuery,
  useGetTestQuery,
  useGetPhonesQuery,
  useAddParticipantMutation,
} = getParticipantsApi;
